import '../social_content_following_comments_view.js.coffee'
Monitoring.Views ||= {}

class Monitoring.Views.DisqusContentFollowingCommentsView extends Monitoring.Views.SocialContentFollowingCommentsView

  initialize: (@options = {}) ->
    super(@options)
    @modelContentId = @socialContent.id

  buildQuery: =>
    @searchQuery = new Monitoring.Models.SearchQuery({}, { use_defaults: false })
    # @searchQuery.addChildCommentsFor(@modelContentId)
    @searchQuery.addContextKind('disqus_following_comments')
    @searchQuery.addTitle(@rootParentId)
    @addContextLimit()
    dateFrom = Date.create(@socialContent.created_at()).getTime() + 1
    @searchQuery.addDateFrom(dateFrom)
    @searchQuery.setNowDate(true)
    @searchQuery.addExcludedContentId(@socialContent.externalId())
